import React, {Fragment, useState, useEffect} from "react";
import Breadcrumb from "../../component/common/breadcrumb/breadcrumb";
import {
    Container,
    Row,
    Col,
    Card,
    CardHeader,
    CardBody,
    Button,
} from "reactstrap";
import ReactDOM from "react-dom";
import CanvasDraw from "react-canvas-draw";
import {toast} from "react-toastify";
import Registration from "../../component/forms/form-layout/formwizad1/registration";
import Email from "../../component/forms/form-layout/formwizad1/email";
import Birthdate from "../../component/forms/form-layout/formwizad1/birthdate";
import ClientData from "./steps/clientdata";
import Declaration from "./steps/declaration";
import VehicleDamage from "./steps/vehicledamage";
import QRGenerator from "./steps/qrgenerator";
import ValidateAndSave from "./steps/validateandsave";
import {useGeolocated} from "react-geolocated";

const ValetProcess = () => {
    const [companies, setCompanies] = useState([]);
    const [editingCompany, setEditingCompany] = useState(null);
    const [showForm, setShowForm] = useState(false);
    const [formdata, setFormdata] = useState({});
    const [steps, setSteps] = useState(1);
    const [transactionId,setTransactionId] = useState(0);
    const [canvas,setCanvas] = useState({});
    useEffect(() => {
        fetchCompanies();
    }, []);

    const { coords, isGeolocationAvailable, isGeolocationEnabled } =
        useGeolocated({
            positionOptions: {
                enableHighAccuracy: false,
            },
            userDecisionTimeout: 5000,
        });
    const fetchCompanies = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_PUBLIC_SERVER}/api/valets`);
            if (response.ok) {
                const data = await response.json();
                setCompanies(data);
            } else {
                toast.error("Error cargando empresas");
            }
        } catch (error) {
            toast.error("Ha ocurrido un error. Por favor intenta de nuevo");
        }
    };

    const addCompany = async (newCompany) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_PUBLIC_SERVER}/api/valets`, {
                method: "POST",
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify(newCompany),
            });
            if (response.ok) {
                const data = await response.json();
                setCompanies([...companies, data]);
                setShowForm(false);
                toast.success("Empresa agregada con éxito");
            } else {
                toast.error("Error agregando empresas");
            }
        } catch (error) {
            toast.error("Ha ocurrido un error. Por favor intenta de nuevo");
        }
    };

    const updateCompany = async (updatedCompany) => {
        try {
            const response = await fetch(
                `${process.env.REACT_APP_PUBLIC_SERVER}/api/valets/${updatedCompany.id}`,
                {
                    method: "PUT",
                    headers: {"Content-Type": "application/json"},
                    body: JSON.stringify(updatedCompany),
                }
            );
            if (response.ok) {
                const data = await response.json();
                setCompanies(
                    companies.map((company) =>
                        company.id === data.id ? data : company
                    )
                );
                setShowForm(false);
                setEditingCompany(null);
                toast.success("Empresa actualizada con éxito");
            } else {
                toast.error("Error actualizando la empresa");
            }
        } catch (error) {
            toast.error("Ha ocurrido un error. Por favor intenta de nuevo");
        }
    };

    const deleteCompany = async (id) => {
        if (window.confirm("¿Estás seguro de que deseas eliminar esta empresa?")) {
            try {
                const response = await fetch(`${process.env.REACT_APP_PUBLIC_SERVER}/api/valets/${id}`, {
                    method: "DELETE",
                });
                if (response.ok) {
                    setCompanies(companies.filter((company) => company.id !== id));
                    toast.success("Empresa eliminada con éxito");
                } else {
                    toast.error("Error al eliminar la empresa");
                }
            } catch (error) {
                toast.error("Ha ocurrido un error. Por favor intenta de nuevo");
            }
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const formData = new FormData(e.target);
        const companyData = {
            id_client:formData.get('id_client'),
            fiscal_identification: formData.get("fiscal_identification"),
            address: formData.get("address"),
            legal_name: formData.get("legal_name"),
            email: formData.get("email"),
            phone: formData.get("phone"),
            password: formData.get("password"),
            staffCount: parseInt(formData.get("staffCount")) || 0,
        };

        if (editingCompany) {
            companyData.id = editingCompany.id;
            updateCompany(companyData);
        } else {
            addCompany(companyData);
        }
        e.target.reset();
    };

    const setContentCanvas = (e) => {
        console.log(e);
    }

    return (
        <Fragment>
            <Breadcrumb parent="Dashboard" title="Valet"/>
            <Container fluid={true}>
                <Row>
                    <Col sm="12" className="text-right">
                        <Button className="form-control btn-info"
                                color="success"
                            onClick={() => {
                                setEditingCompany(null);
                                setShowForm(true);
                            }}
                        >
                            Nueva Recepción
                        </Button>
                    </Col>
                </Row>
                {showForm && (
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardHeader>
                                <h5>Recibir Vehiculo</h5>
                            </CardHeader>
                            <CardBody>
                                {steps === 1 && <ClientData setSteps={setSteps} setFormdata={setFormdata} formdata={formdata} initial_gps={"-10.000 10.000"} setShowForm={setShowForm} valetName={localStorage.getItem('valetName')} valetId={localStorage.getItem('valetId')} />}

                                {steps === 2 && <Declaration setSteps={setSteps} setFormdata={setFormdata} formdata={formdata} />}

                                {steps === 3 && <VehicleDamage setSteps={setSteps} setFormdata={setFormdata} formdata={formdata} setSaveableCanvas={setContentCanvas} />}

                                {steps === 4 && <ValidateAndSave setSteps={setSteps} setFormdata={setFormdata} formdata={formdata} setTransactionId={setTransactionId} />}

                                {steps === 5 && <QRGenerator setSteps={setSteps} setFormdata={setFormdata} formdata={formdata} qrcontent={"http://localhost:3000/requestCar/"+transactionId+"/"+localStorage.getItem("valetId")+"/"+formdata.id_customer+"/"+localStorage.getItem("token")} />}

                                <div className="text-center">
                                    <span className={`step ${steps > 1 ? "finish" : ""} ${steps === 1 ? "active" : ""}`} />
                                    <span className={`step ${steps > 2 ? "finish" : ""} ${steps === 2 ? "active" : ""}`} />
                                    <span className={`step ${steps > 3 ? "finish" : ""} ${steps === 3 ? "active" : ""}`} />
                                    <span className={`step ${steps > 4 ? "finish" : ""} ${steps === 4 ? "active" : ""}`} />
                                    <span className={`step ${steps > 5 ? "finish" : ""} ${steps === 5 ? "active" : ""}`} />
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>)}
            </Container>
        </Fragment>
    );
};

export default ValetProcess;
